import { render, staticRenderFns } from "./tobepaid.vue?vue&type=template&id=a04f96b4&scoped=true"
import script from "./tobepaid.vue?vue&type=script&lang=js"
export * from "./tobepaid.vue?vue&type=script&lang=js"
import style0 from "./tobepaid.vue?vue&type=style&index=0&id=a04f96b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04f96b4",
  null
  
)

export default component.exports